// @flow
import React, { useState, useEffect } from 'react';
import Typography from '@justpark/ui/src/components/Typography';
import bem from '@justpark/helpers/src/bem/bem';
import GlobalModal from '../UI/GlobalModal';
import { getQueryParam } from '../../helpers/utils';
import PromoApplied from '../../svg/promo-applied.svg';

import '../../../static/scss/components/promoModal.scss';

type Props = {
  searchQuery: string
};

const getPromoCodeErrorFromCode = code => {
  if (!code) {
    return '';
  }

  if (code === 'promo_code_already_redeemed') {
    return 'Unfortunately this promotion has already been redeemed';
  }

  if (code === 'promo_code_doesnt_exist') {
    return 'This promotion is not valid or does not exist';
  }

  if (code === 'promo_code_unredeemed') {
    return 'Unfortunately this promotion cannot be applied at this time';
  }

  return '';
};

const baseClass = 'c-promo-modal';

const PromoModal = ({ searchQuery }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const promoCodeQuery = getQueryParam(searchQuery, 'promo_code');
  const errorCode = getQueryParam(searchQuery, 'promo_code_error');
  const error = getPromoCodeErrorFromCode(errorCode);
  const promoSuccess = promoCodeQuery === 'success';

  useEffect(
    () => {
      if (promoCodeQuery === 'success' || promoCodeQuery === 'error') {
        setIsOpen(true);
      }
    },
    [promoCodeQuery]
  );

  return (
    <GlobalModal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      onConfirmationClick={() => setIsOpen(false)}
      hasConfirmationButton
      buttonCTA="Ok, got it"
      className={baseClass}
      hideClose
      noOverflow
    >
      <div className={bem(baseClass, 'body', { promoCodeQuery })}>
        {promoSuccess ? (
          <>
            <PromoApplied className={bem(baseClass, 'image')} />
            <h3 className={bem(baseClass, 'title')}>Promo applied</h3>
            <Typography color="light" size="primary">
              <p className={bem(baseClass, 'text')}>
                Your promo has been applied to your account and will be redeemed
                with your first qualifying booking
              </p>
            </Typography>
          </>
        ) : (
          <>
            <h3 className={bem(baseClass, 'title')}>
              Unable to apply your promotion
            </h3>
            <Typography color="light" size="primary">
              <p className={bem(baseClass, 'text')}>{error}</p>
            </Typography>
          </>
        )}
      </div>
    </GlobalModal>
  );
};

export default PromoModal;
